import CollapsePanel from './Panel'
import Collapse from './Collapse'

Collapse.Panel = CollapsePanel

export default Collapse



// WEBPACK FOOTER //
// ./components/collapse/src/index.js